export const locale = {
  lang: 'pt',
  data: {
    'CONFIRMACION': {
      'FELICI':'¡PARABÉNS, CHEGOU AO FIM DO PROCESSO DE CONFIGURAÇÃO!',
      'INDICACION':'Para tornar o seu inquérito activo e pronto a ser aplicado nas datas configuradas, deve clicar no botão activar inquérito',
      'CONFIRMAR':'Activar sondagem',
      'IND_CONFIRM_JP': 'Antes de prosseguir com a activação do inquérito, é necessário confirmar as informações previamente configuradas',
      'BTN_CONFIRM_INFO': 'Confirmar informação ',
      'IND_ESP_CONFIRM_JP':'Assim que o gerente de projeto confirmar, prosseguiremos com a ativação da pesquisa',
      'MOD_TIT_CONGR_CONF':'Obrigado por sua confirmação',
      'MOD_ESP_CONFIRM_JP':'Precisamos apenas da aprovação do gerente de projeto para prosseguir com a ativação da pesquisa',
      'CERRAR-CONFIRMAR':'Desactivar inquérito',
      'MESSAGE5':'Inquérito activo e pronto a ser aplicado',
      'HISTORY_ACTIVATION_1': 'Última Ativação / Desativação',
      'HISTORY_ACTIVATION_2': 'Histórico de ativação:',
      'ESTATUS_SURVEY':{
      '0':'Desativação',
      '1':'Ativação',
      '2':'Fechadas',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          // 'MESSAGE1':'<span>Para continuar a activação do inquérito',
          // 'MESSAGE2':', introduzir o texto a vermelho na caixa de texto</span>',
          'MESSAGE1':'<span> Anketin etkinleştirilmesine devam etmek için metin kutusuna kırmızı metni girin ',
          'MESSAGE2':'</span>',
          'SALIR': 'Cancelar',
          'VALIDAR': 'Confirme',
          'ERRORNOMBREEMPRESA': 'O texto introduzido não corresponde ao texto apresentado a vermelho',
          'SUCCES': ' O inquérito foi activado',
          'CERRAR': 'Fechar',
          'SUCCES-DES': 'nquérito desactivado',
          'MESSAGE3':'<span> Para continuar a desactivar o inquérito, introduzir o texto vermelho na caixa de texto: ',
          'MESSAGE4':'</span>',
          'MESSAGE5':'O inquérito já tem resultados, tem a certeza de que o pode desactivar?',
          'MESSAGE6':'Actualmente não há nenhum inquérito',
          'BTN-ACEPTAR': 'Aceitar',
          'BTN-CANCELAR': 'Cancelar',
          'BTN-OK': 'Ok',
          'HORAMINIMA': 'Não foi possível confirmar a comunicação por e-mail, a data do primeiro e-mail a enviar (lançamento ou primeira notificação, consoante o caso) tem que ser superior a duas horas a partir deste momento \n\nSe necessário, volte a definir as datas'
        },
        },
  },
  }
};
